const collections = {
  organizations: 'organizations',
  chats: 'chats',
  clients: 'clients',
  users: 'users',
};
export default collections;
